export default __webpack_public_path__ + "static/media/link.bcb6c136.svg";